module.exports = __webpack_public_path__ + "public/Icons/languageIcon.png?831c2768";